
'use client'
import React, { useContext, useEffect, useState,useCallback,memo,useRef,useMemo } from "react";
import { useScreenshot } from "use-react-screenshot";
import Services from "../../network/Services";
import { debounce } from "lodash";
import commonLib from "../../control/commonLib";
import { UserContext } from "../../App";
import config from '../../config.json';
import {message} from "antd";
import { isNullUndefine } from "../../control/Constant";
import { CRM_BASEURL } from "../../network/url";

export default function FeedBackModal ({ useNewFeedback }) {
    const [showModal, setShowModal] = useState(false);
    const [selectedPriority, setSelectedPriority] = useState('2');
    const [descriptionValue, setDescriptionValue] = useState("");
    const [feedbackPriority, setFeedbackPriority] = useState()
    const [imageSrc, takeScreenshot] = useScreenshot();
    const [feedbackImg, setFeedbackImg] = useState(null);
    const { setLoader } = useContext(UserContext);
    const userLoggedInDetail = commonLib.getObjFromStorage("userLoggedInDetail");
    const stateObj = commonLib.getObjFromStorage("stateObj");
    const subtenantId = commonLib.getObjFromStorage("subtenantId");
    const currentTime = new Date().toLocaleString();

    useEffect(() => {
        getFeedbackPriority()
    }, []);

    const getFeedbackPriority = () => {
        setLoader(true);
        const promise = Services.getFeedbackPriority();
        promise.then((response) => {
            setFeedbackPriority(response?.data?.data)
            setLoader(false)
        }).catch((e) => {
        }).finally(() => {
          setLoader(false)
     });
    };

    const captureFullScreenshot = async () => {
        const domtoimage = (await import('dom-to-image-more')).default;
        const iframeWindow = document.querySelector('iframe')?.contentWindow;

        // 1. Find scrollable divs and temporarily replace scroll with margin
        const scrolledEls = [];
        document.querySelectorAll('.sideBars').forEach(el => {
            const style = getComputedStyle(el);
            const isScrollable = style.overflowY === 'auto' || style.overflowY === 'scroll';
            if (isScrollable && el.scrollTop > 0) {
                scrolledEls.push({
                el,
                scrollTop: el.scrollTop,
                overflow: el.style.overflowY,
                height: el.style.height
                });
                // Shift inner content to simulate scroll position
                el.style.overflowY = 'hidden';
                el.children[0] && (el.children[0].style.marginTop = `-${el.scrollTop}px`);
            }
        });

        await new Promise(r => setTimeout(r, 50));

        const dataUrl = await domtoimage.toPng(document.body, {
            quality: 1,
            scale: window.devicePixelRatio,
            filter: (node) => {
                if (node.classList?.contains('overLayLoader')) {
                    return false;
                }
                if (node.id === 'feedbackId') {
                    return false;
                }
                return true;
            },
            onclone: (clonedDoc) => {
                const overlays = clonedDoc.querySelectorAll('noscript');
                overlays.forEach(el => {
                    el.style.display = 'none';
                });
            },
        });

        // 2. Restore everything
        scrolledEls.forEach(({ el, scrollTop, overflow }) => {
            el.style.overflowY = overflow;
            el.children[0] && (el.children[0].style.marginTop = '');
            el.scrollTop = scrollTop;
        });

        if(iframeWindow) {
            const crmUrl = CRM_BASEURL;
            // const crmUrl = 'http://localhost:3001';

            // Request screenshot from iframe with a timeout fallback
            const iframeScreenshot = await Promise.race([
                // Try to get iframe screenshot
                new Promise((resolve) => {
                window.addEventListener('message', (e) => {
                    if (e.origin != crmUrl) return;
                    if (e.data.type === 'screenshot') resolve(e.data.data);
                }, { once: true });
                iframeWindow.postMessage('capture-screenshot', crmUrl);
                }),
                // Timeout after 10 seconds - resolve with null
                new Promise((resolve) => setTimeout(() => resolve(null), 20000))
            ]);

            if(!iframeScreenshot) {
                message.warning("Failed to capture products & plans screenshot.");
                setFeedbackImg(dataUrl);
                return;
            }

            // Stitch them together on a canvas
            const iframeEl = document.querySelector('iframe');
            const rect = iframeEl.getBoundingClientRect();

            const mainImg = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.src = dataUrl;
            });

            const canvas = document.createElement('canvas');
            canvas.width = mainImg.width;
            canvas.height = mainImg.height;
            const ctx = canvas.getContext('2d');

            // Draw main page
            ctx.drawImage(mainImg, 0, 0);

            // Draw iframe screenshot on top
            const iframeImg = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.src = iframeScreenshot;
            });

            ctx.drawImage(
                iframeImg, 
                rect.left * window.devicePixelRatio, 
                rect.top * window.devicePixelRatio, 
                // rect.width * window.devicePixelRatio, 
                // rect.height * window.devicePixelRatio
                iframeImg.width,
                iframeImg.height
            );

            const finalScreenshot = canvas.toDataURL();
            setFeedbackImg(finalScreenshot);
            return;
        }

        setFeedbackImg(dataUrl);
    };

    const handleFeedbackShow = async () => {
        if(showModal == false) {
            setLoader(true);
            if(useNewFeedback) {
                await captureFullScreenshot();
            } else {
                await takeScreenshot(document.body);
            }
            setLoader(false);
            if(!feedbackPriority?.length) getFeedbackPriority();
        } else {
            resetState();
        }
        setShowModal(!showModal);
    }

    const resetState = () => {
        setSelectedPriority('2');
        setDescriptionValue("")
    }

    const isAnyErr = (someResponse) => {
        if (someResponse == "err") {
            message.warning("Something went wrong, please try again later.")
            setLoader(false);
            return true;
        }
        return false;
    }


    const handleFeedbackSubmit = async () => {

        if (descriptionValue == "") {
            message.warning("Feedback query cannot be blank.");
            return;
        }
        setLoader(true);

        // 1) Upload Image
        const imageUploadResObj = await handleImageSubmit();
        if (isAnyErr(imageUploadResObj)) {
            setLoader(false);
            return;
        }

        // 2) Submit Feedback
        const feedbackPostRes = await postFeedback(imageUploadResObj);
        if (isAnyErr(feedbackPostRes)) {
            setLoader(false);
            return;
        }

        // 3) Send Email with Attachment
        const postEmailRes = await sendFeedBackEmail(imageUploadResObj?.blob, subtenantId, feedbackPostRes);
        if (isAnyErr(postEmailRes)) {
            setLoader(false);
            return;
        }

        // 4) Acknowledgement Email
        const acknowledgeMailRes = await functionForAcknowledgementMail(feedbackPostRes);
        if (isAnyErr(acknowledgeMailRes)) {
            setLoader(false);
            return;
        }

        // 5) Everything Successful

        message.success("Feedback submitted successfully");
        setLoader(false);
        handleFeedbackShow();
    };


    const handleImageSubmit = () => {
        return new Promise(async (resolve) => {
            // setLoader(true);
            const fileTypeId = 3;
            const fileCategoryId = 7;
            const fileStatusId = 2;
            const blob = await fetch(imageSrc).then(res => res.blob());
            const file = new File([blob], "FEEDBACK.jpg", { type: "image/png" });
            await Services.postFileUpload(file,stateObj?.userId,stateObj?.userId,fileTypeId,fileCategoryId,fileStatusId).then((response) => {
                    const imageUrl = response?.data?.data?.fileURL;
                    const fileId = response?.data?.data?.fileId;
                    resolve({ imageUrl, fileId, blob });
                }).catch(() => {
                    resolve("err");
                    setLoader(false)
                }) .finally(() => {
                    // setLoader(false);
                });

        });
    };





    const postFeedback = async (imageUploadResObj) => {
        const { imageUrl, fileId } = imageUploadResObj;

        const payload = {
            userId: stateObj?.userId,
            feedbackQuery: descriptionValue,
            feedbackType: "string",
            applicationURL: window.location.href,
            imageURL: imageUrl,
            fileId: fileId,
            createdBy: stateObj?.userId,
            moduleTypeId: 6,
            feedbackPriorityId: selectedPriority
        };
        try {
            // setLoader(true);
            const response = await Services.postFeedback(payload);
            return response;
        } catch (err) {
            setLoader(false);
            return "err";
        } finally {
        }
    };



    const sendFeedBackEmail = async (blob, subtenantId, res) => {
        return new Promise(async (resolve) => {

            const file = new File([blob], "FEEDBACK.jpg", { type: "image/png" });

            let emailto = (!config?.DEMO && subtenantId == 742) ? "TechSupport@agingoptions.com" : "satyadev.sharma@agingoptions.com";
            let emailContent = `
      <p style="font-size: 16px; color: #333; background-color: #f5f5f5; padding: 10px; margin: 0; box-sizing: border-box;">
        <span style="display: block; padding-bottom: 10px;"><b>Ticket Number:</b> @@ticketno<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Name:</b> @@CLIENT_NAME<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Email:</b> @@CLIENT_EMAIL<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Sender Email:</b> @@SENDER_EMAIL<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Application URL:</b> @@APPLICATION_URL<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Query:</b> @@FEEDBACK_QUERY<br></span>
        <span style="display: block; padding-bottom: 10px;"><b>Time:</b> @@time</span><br>
      </p>
      <p>(<b>Note:</b> Sent from @@USERTYPE)</p>
                               `;

            emailContent = emailContent
                .replace('@@CLIENT_NAME', userLoggedInDetail?.memberName)
                .replace('@@CLIENT_EMAIL', userLoggedInDetail?.primaryEmailId)
                .replace('@@SENDER_EMAIL', userLoggedInDetail?.primaryEmailId)
                .replace('@@FEEDBACK_QUERY', descriptionValue)
                .replace('@@APPLICATION_URL', window.location.href)
                .replace('@@time', currentTime)
                .replace('@@USERTYPE', 'Admin')
                .replace('@@ticketno', res?.data?.data?.feedbackId);

            let formData = new FormData();
            formData.append('File', file);
            formData.append('EmailType', 'Client_Feedback_Details');
            formData.append('EmailTo', emailto);
            formData.append('EmailSubject', 'Feedback Details');
            formData.append('EmailContent', emailContent);
            formData.append('EmailMappingTable', 'tblMember');
            formData.append('EmailStatusId', '1');
            formData.append('EmailMappingTablePKId', stateObj?.userId);
            formData.append('CreatedBy', stateObj?.userId);

            setLoader(true);
            await Services.sendMailFeedBack(formData).then((response) => {
                resolve(response);
            }).catch(() => {
                setLoader(false);
                resolve("err");
            }).finally(() => {
            });

        });
    };




    const functionForAcknowledgementMail = async (response) => {
        return new Promise(async (resolve) => {

            let emailContent = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Feedback Acknowledgement | New Ticket @@ticketno</title>
        </head>
        <body>
          <p>Hi @@CLIENT_NAME,</p>
          <p>We would like to acknowledge that we have received your request and a ticket @@ticketno has been created.</p>
          <p><b>Ticket Details</b></p>
          <p>Ticket No.: @@ticketno</p>
          <p>Ticket Title: @@FEEDBACK_QUERY</p>
          <p>Rest assured, our tech support team has initiated an investigation based on your feedback.</p>
          <p>Warm regards,</p>
          <p>Tech Support Team<br>Aging Options</p>
        </body>
      </html>
    `;

            emailContent = emailContent
                .replace('@@CLIENT_NAME', userLoggedInDetail?.memberName)
                .replace('@@FEEDBACK_QUERY', descriptionValue)
                .replace(/@@ticketno/g, response?.data?.data?.feedbackId);

            const jsonObj = {
                emailType: "Client_Feedback_Details",
                emailTo: userLoggedInDetail?.primaryEmailId,
                emailSubject: `Feedback Acknowledgement | New Ticket ${response?.data?.data?.feedbackId}`,
                emailContent: emailContent,
                emailStatusId: 1,
                emailMappingTable: "tblMember",
                emailMappingTablePKId: stateObj?.userId,
                createdBy: stateObj?.userId,
            };

            setLoader(true);

            await Services.sendPostEmailCC(jsonObj).then((res) => {
                    resolve(res);
                }).catch(() => {
                    setLoader(false);
                    resolve("err");
                }).finally(() => {
                });

        });
    };




    return (
        <>
        <div id='feedbackId' className="useNewDesignSCSS">
            <div className="openFeedbackBtn">
                <CustomButton
                    label="Feedback"
                    disabled={showModal}
                    onClick={handleFeedbackShow}
                />
            </div>

            {showModal && <div className="feedbackModal" enforceFocus={false}>
                <div id="newModal" className='modals'>
                    <div className="modal" style={{ display: 'block',zIndex:'9999',backgroundColor: 'rgba(112, 100, 100, 0.7490196078)'}}>
                        <div className="modal-dialog costumModal" style={{ maxWidth: '60%', margin: 'auto', padding: '10px'}}>
                            <div className="costumModal-content">
                                <div className="modal-header">
                                    <p className="modal-title" style={{fontSize: '20px', color: '#474747'}}>Feedback</p>
                                    <img className='mt-0 cursor-pointer'style={{width:"20px"}} onClick={handleFeedbackShow} src='/closeIcon.svg'></img>

                                </div>
                                <div className="costumModal-body">
                                    <div className="feedbackBody">
                                        <div className="d-flex justify-content-between flex-wrap align-items-center" style={{gap: '10px'}}>
                                            <p className="mb-0">Name: {userLoggedInDetail?.memberName}</p>
                                            <p className="mb-0">Time: {currentTime}</p>
                                            {<div className="d-flex align-items-center" style={{gap: '5px'}}>
                                                <p className="mb-0">Priority:</p>
                                                <CustomSelect
                                                    id="Priority"
                                                    placeholder="Select priority"
                                                    tabIndex={100}
                                                    onChange={(item) => setSelectedPriority(item?.value)}
                                                    value={selectedPriority}
                                                    options={feedbackPriority}
                                                />
                                            </div>}
                                        </div>
                                        <div style={{marginTop: '10px'}}>
                                            <CustomTextarea
                                                label="Describe"
                                                id="Describe"
                                                tabIndex={200}
                                                onChange={setDescriptionValue}
                                                value={descriptionValue}
                                            />
                                        </div>
                                        <div className="feedbackImg">
                                            <img width="100%" src={useNewFeedback ? feedbackImg : imageSrc} alt={"Screenshot"} style={{ borderRadius: "2px", margin: '10px 0' }} crossOrigin="anonymous" />
                                        </div>
                                    </div>
                                    <div className='submit-btns'>
                                        <CustomButton
                                            tabIndex={400}
                                            onClick={handleFeedbackShow}
                                            label={'Cancel'}
                                        />
                                        <CustomButton
                                            tabIndex={300}
                                            onClick={handleFeedbackSubmit}
                                            label={'Submit'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
        </>

    )
}


export const CustomTextarea = memo(({ label, value, id, onChange, placeholder, rows, tabIndex, onHoverTitle, isDisable, refrencePage }) => {
    const textareaRefs = useRef(null);
    const adjustHeight = () => {
        const textarea = textareaRefs?.current;
        if (textarea) {
            textarea.style.height = 'auto'; // Reset height to auto
            textarea.style.height = `${textarea.scrollHeight}px`; // Adjust height based on scrollHeight
        }
    };

    const handleChange = (e) => {
        const textarea = textareaRefs?.current;
        const cursorPosition = textarea?.selectionStart;

        onChange(removeSpaceAtStart(e?.target?.value), id);

        setTimeout(() => {
            if (textarea) {
                textarea?.setSelectionRange(cursorPosition, cursorPosition);
                adjustHeight();
            }
        }, 0);
    };

    useEffect(() => {
        adjustHeight(); // Adjust height on value change
    }, [value]);
    return (
        <div id='custom-textarea-field' className="w-100 custom-textarea-field"
        >
            {!isNullUndefine(label) && <p className="pb-0 mb-1" title={onHoverTitle} style={{paddingBottom:"0px"}} >{label}</p>}
            <textarea ref={textareaRefs}
                tabIndex={tabIndex}
                className='textareaStyling'
                style={{ textTransform: "none", minWidth: refrencePage == 'AgentGuidance' ? '100%' : "", resize: 'vertical', overflow: 'hidden', ...(isDisable && { backgroundColor: "rgb(185, 183, 183)", opacity: "0.5", cursor: 'not-allowed' })}}
                placeholder={placeholder ?? ''}
                id={id}
                value={!isNullUndefine(value) ? value :''}
                onChange={(e)=>handleChange(e)}
                rows={rows ?? 3}
                disabled={isDisable}
            />
        </div>
    );
});
export const CustomButton = memo((props) => {
    const { label, onClick, tabIndex, disabled} = props;
    const [isProcessing, setIsProcessing] = useState(false);

    const debouncedOnClick = useCallback(
        debounce(async (event) => {
            if (disabled || isProcessing) return;
            setIsProcessing(true);
            await onClick(event);
            setIsProcessing(false);
        }, 300),
        [disabled, isProcessing, onClick]);

    const handleClick = (event) => {
        if (event?.type == "keydown" && event?.key == "Enter") {
            event?.preventDefault();
            debouncedOnClick(event);
        }
        if (event?.type == "click") {
            debouncedOnClick(event)
    }}

    return (
         <button tabIndex={tabIndex} disabled={disabled || isProcessing} className={`custom-button ${disabled || isProcessing ? 'disable-btn' : ''}`} onClick={handleClick} onKeyDown={handleClick}>
            {label}
        </button>
    );
});
export const removeSpaceAtStart = (value) => {
  if (typeof value != "string") return value;
  return value?.replace(/^\s+/g, '');
}
export const CustomSelect = memo(({ options, label, value, placeholder, onChange, dob, name, isError, isDisable, tabIndex, id, isPersonalMedical, isNonMonthlyExpense }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const [typedChars, setTypedChars] = useState("");
    const typingTimeout = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => { // TO SCROLL WHEN DROP DOWN OPENS HIDDEN
        isOpen && document?.getElementById('dropDownDivId')?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, [isOpen])

    const toggleDropdown = useCallback(() => {
        setIsOpen((prev) => !prev);
        if (isOpen) {
            setHighlightedIndex(-1);
        }
    }, [isOpen]);

    const handleOptionClick = useCallback((option) => {
        onChange(option);
        setTimeout(() => {
        setIsOpen(false);
        setHighlightedIndex(-1);
        }, 0);
    }, [onChange]);

    const sortedOptions = useMemo(() => {
        return options
    }, [options]);

    const handleKeyDown = useCallback((event) => {
        if (isDisable) return;
        if (event?.key == "ArrowDown" || event?.key == "ArrowUp") {
            // if (isOpen) {
            const direction = event?.key == "ArrowDown" ? 1 : -1;
            setHighlightedIndex((prev) => {
                let nextIndex = prev + direction;
                if (nextIndex < 0) nextIndex = 0;
                if (nextIndex >= sortedOptions?.length) nextIndex = sortedOptions?.length - 1;
                const nextOption = sortedOptions?.[nextIndex];
                onChange(nextOption);
                    return nextIndex;
                });
                event?.preventDefault();
            // }
            } else if (event?.key == "Enter") {
                if (highlightedIndex >= 0 && sortedOptions?.[highlightedIndex]) {
                    handleOptionClick(sortedOptions?.[highlightedIndex]);
            } else {
                setIsOpen(true);
            }
                event?.preventDefault();
            } else if (event?.key == "Tab") {
                if (highlightedIndex >= 0 && sortedOptions?.[highlightedIndex]) {
                    handleOptionClick(sortedOptions?.[highlightedIndex]);
                }
                setIsOpen(false);
            setHighlightedIndex(-1);
            } else if (event?.key == "Escape") {
                setIsOpen(false);
            setHighlightedIndex(-1);
                event.preventDefault();
             } else if (/^[a-zA-Z0-9]$/.test(event.key)) {
            // Type-to-select logic
            const newTyped = typedChars + event.key.toLowerCase();
            setTypedChars(newTyped);

            clearTimeout(typingTimeout.current);
            typingTimeout.current = setTimeout(() => {
                setTypedChars("");
            }, 500);

            const matchIndex = sortedOptions?.findIndex(ele =>
                ele?.label?.toLowerCase().startsWith(newTyped)
            );

            if (matchIndex !== -1) {
                setHighlightedIndex(matchIndex);
            }

            event.preventDefault();
        }
    }, [isDisable, isOpen, sortedOptions, highlightedIndex, handleOptionClick, typedChars]);

    useEffect(() => {
        return () => {
            clearTimeout(typingTimeout.current);
        };
    }, []);

    const getLabel = useCallback((id, value, options, placeholder) => {

        if (id == "liabilityTypeId" && value?.label) {
            return value?.label || placeholder;
        }
        if (highlightedIndex >= 0 && !isOpen) {
            return sortedOptions?.[highlightedIndex]?.label || placeholder;
        }
        const selectedOption = Array.isArray(options) ? options.find((item) => item?.value == value) : undefined;
        return selectedOption ? selectedOption?.label : placeholder;
    }, [id, value, options, placeholder, highlightedIndex, isOpen, sortedOptions]);


    const handleClickOutside = useCallback((event) => {
        if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
            setIsOpen(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);
    const renderedOptions = useMemo(() => {
        if (sortedOptions?.length > 0) {
            return (
                <>
                    {sortedOptions?.map((option, index) => (
                        <li key={index} onClick={() => handleOptionClick(option)}
                            className={`${highlightedIndex === index ? "highlighted" : ""} ${/^(other)$/i.test(option.label) ? "otherValueName" : ""
                                }`}
                        >
                            {option?.label || placeholder}
                        </li>
                    ))}
                </>
            );
        } else {
            return <span className="text-center ps-3">Not available</span>;
        }
    }, [sortedOptions, handleOptionClick, highlightedIndex, placeholder]);

    return (

        <div ref={dropdownRef} className={`${!isNullUndefine(isError) ? "custom-select-field error-msg-focus" : "custom-select-field "} ${isPersonalMedical ? "full-width" : ""}`} onKeyDown={handleKeyDown} >

            <div className={`${(isDisable == true) ? 'disabled-div-select' : ''} dropdown`} tabIndex={tabIndex}   >
                <div className={`${(!isNullUndefine(value) && options?.find(item => item.value == value)?.label ? '' : '')} dropdown-selected`} onClick={toggleDropdown} >
                    <span style={{ fontWeight: "400" }}>{getLabel(id, value, options, placeholder)}</span>
                </div>
                <div className={`dropdown-icon ${isOpen ? 'dropdown-icon-bg' : ''}`} onClick={toggleDropdown} id={id} >
                    <img className="mt-0" src="/select-icon.png" alt="Dropdown icon" />
                </div>
            </div>
            {isOpen && (
                <ul id="dropDownDivId" className="dropdown-options" name={name} style={id == "closestRelative" ? { maxHeight: "200px", padding: '10px' } : isNonMonthlyExpense ? { maxHeight: "160px", padding: '10px', position: 'absolute', bottom: '0' } : { padding: '10px', overflowY:"auto", maxHeight:"200px" }}>
                    {renderedOptions}
                </ul>
            )}

            {!isNullUndefine(isError) && <span className="err-msg-show mt-1">{isError}</span>}

        </div>
    );
});